export const NOT_ENOUGH_BALANCE_CODE = 102
